import './CtaButtons.scss';

import classNames from 'classnames';
import { cloneElement, ReactElement } from 'react';

import Button from '../Button';
import { ButtonProps } from '../Button/Button';

interface Props {
  PrimaryCta?: ReactElement<ButtonProps, typeof Button>;
  SecondaryCta?: ReactElement<ButtonProps, typeof Button>;
  fluid?: boolean;
}

const baseClassName = 'c-CtaButtons';

export const CtaButtons = ({
  PrimaryCta,
  SecondaryCta,
  fluid = false,
}: Props) => {
  const hasCTAs = PrimaryCta || SecondaryCta;
  if (!hasCTAs) {
    return null;
  }

  return (
    <div
      className={classNames(
        baseClassName,
        fluid ? `${baseClassName}-fluid` : '',
      )}
    >
      {PrimaryCta ? cloneElement(PrimaryCta, { mobileFluid: true }) : null}
      {SecondaryCta ? cloneElement(SecondaryCta, { mobileFluid: true }) : null}
    </div>
  );
};
